<template>
  <div class="menu" :class="{'is-visible': isMenuOpened}">
    <ul class="menu__list">
      <li @click="goToArticle('article1')">
        {{ 'Росмолодежь и #МЫВМЕСТЕ' | typograf }}
      </li>
      <li @click="goToArticle('article2')">
        {{ 'Как волонтерство изменило жизнь деревни Пятково' | typograf }}
      </li>
      <li @click="goToArticle('article3')">
        {{ 'Как добровольческое движение спасает жизни' | typograf }}
      </li>
      <li @click="goToArticle('article4')">
        {{ 'Что посмотреть перед Новым годом?' | typograf }}
      </li>
      <li @click="goToArticle('article5')">
        {{ 'Новогодние чудеса для детей и взрослых' | typograf }}
      </li>
      <li @click="goToArticle('article6')">
        {{ 'Праздник для всех и от каждого' | typograf }}
      </li>
      <li @click="goToArticle('article7')">
        {{ 'Новогодние добровольцы. Как найти доброе дело по душе' | typograf }}
      </li>
    </ul>
  </div>
</template>

<script>
  import './menu.scss'
  import { mapState } from 'vuex'
  export default {
    name: "Menu",
    computed: {
      ...mapState([
        'isMenuOpened'
      ])
    },
    methods: {
      goToArticle(hash) {
        this.$store.commit('TOGGLE_MENU')
        location.hash = hash
      }
    }
  }
</script>

<style scoped>

</style>
